import VueChartJs from 'vue-chartjs'

export default {
  extends: VueChartJs.Pie,
  props: ['chartData', 'labels'],
  data: function () {
    return {
      options: {
        tooltips: {
          enabled: false
        },
        legend: {
          onClick: (e) => e.stopPropagation(),
          display: true,
          labels: {
            fontSize: 40
          }
        },
        responsive: false,
        maintainAspectRatio: false,
        animation: false
      }
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    'chartData' (to, from) {
      this.render()
    },
    'labels' (to, from) {
      this.render()
    }
  },
  methods: {
    render () {
      console.log('render')
      var data = {
        label: 'Data One',
        backgroundColor: ['#023047', '#219EBC', '#8ECAE6'],
        pointBackgroundColor: 'white',
        borderWidth: 1,
        pointBorderColor: '#249EBF',
        data: this.chartData
      }

      this.renderChart({
        labels: this.labels,
        datasets: [
          data
        ]
      }, this.options)
    },
    export2image: function () {
      let image = document.getElementById(this.$attrs.id).querySelector('canvas').toDataURL('image/png')
      return image
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PieChart.js